export const deviceType = {
    1: 'MANTRA MFSTAB II',
    2: 'PDA CARIBE PL50L',
    3: 'TELPO F6',
    4: 'TELPO TPS 980',
    5: 'TELPO TPS 450',
    6: 'TELPO K5',
    7: 'TELPO F10',
};
